import getPages from './pages';

const getPage = (rootState, pageId) =>
  getPages(rootState).find((page) => page.id === pageId) || null;

export default getPage;
